var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"40px"}}),_vm._v(" "),_c('div',{staticClass:"ctitle"},[_c('img',{staticClass:"service-around",attrs:{"src":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v(_vm._s(_vm.desc))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-471b9dc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CTitle.vue
// module id = null
// module chunks = 